import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import KakobuyArticle from "../pages/article/KakobuyPage";
import CssbuyArticle from "../pages/article/CssbuyPage";
import SuperbuyArticle from "../pages/article/SuperbuyPage";
import OopbuyArticle from "../pages/article/OopbuyPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuyArticle />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CssbuyArticle />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuyArticle />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;